<script>
export default {
    name:"NavIcon",
    props: {
        iconName: {
            type: String,
            required: true
        },
        
    }
}
</script>

<template>
    <div class="icon">
        <div class="wrapper bg-blue rounded-circle">
            <font-awesome-icon class="white fs-5" :icon="['fas', iconName]" />
        </div>
    </div>
</template>




<style lang="css" scoped>    

    .icon {
        display: flex;
        align-content: center;
        cursor: pointer;
        /* margin-left: 0.75rem; */
    }

    .white {
        color: white;
    }

    .wrapper {
        display: flex;
        justify-content: center;
        align-items: center;        
        width: 30px;
        height: 30px;        
    }
</style>
